var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResponseAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#E52730"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0284 12.2344H8.88639L8.43639 3.64844H11.4784L11.0284 12.2344ZM8.40039 15.2404C8.40039 14.6884 8.55039 14.3044 8.85039 14.0884C9.15039 13.8604 9.51639 13.7464 9.94839 13.7464C10.3684 13.7464 10.7284 13.8604 11.0284 14.0884C11.3284 14.3044 11.4784 14.6884 11.4784 15.2404C11.4784 15.7684 11.3284 16.1524 11.0284 16.3924C10.7284 16.6204 10.3684 16.7344 9.94839 16.7344C9.51639 16.7344 9.15039 16.6204 8.85039 16.3924C8.55039 16.1524 8.40039 15.7684 8.40039 15.2404Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponseAlert);
export default __webpack_public_path__ + "static/media/response_alert.30e86c8338f39e0477e9adbfe69b32cd.svg";
export { ForwardRef as ReactComponent };